import {HttpClient} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import {StringUtils} from '@app/core/utils/string.utils';
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';
import {IStaticPages} from '../model/static-pages.model';

@Injectable({
  providedIn: 'root',
})
export class StaticPagesService {
  private readonly _httpClient = inject(HttpClient);

  private staticPageUrl = `${environment.api.baseUrl}/${environment.api.static.getStaticPages}`;

  getStaticPage(key: number, languageId: number): Observable<IStaticPages> {
    const expectedStaticPageUrl = StringUtils.ReplaceTokens(this.staticPageUrl, {key, languageId});
    return this._httpClient.get<IStaticPages>(expectedStaticPageUrl);
  }
}
